import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import InviteMore from './InviteMore';
import OverAllocated from './OverAllocated';

export interface Props {
  activationsRemaining: number;
  publicName: string;
  newLicenseAllocations: number;
  allocatedLicenses: number;
}

export const whenNotAllLicensesAllocated = (
  allocatedLicenses: number,
  newLicenseAllocations: number,
  activationsRemaining: number,
) => when(allocatedLicenses + newLicenseAllocations < activationsRemaining, {});

function ActivationsRemaining({
  activationsRemaining,
  publicName,
  newLicenseAllocations,
  allocatedLicenses,
}: Props) {
  return whenNotAllLicensesAllocated(allocatedLicenses, newLicenseAllocations, activationsRemaining)
    .map(() => (
      <InviteMore
        newLicenseAllocations={newLicenseAllocations}
        productLicensePublicName={publicName}
        activationsRemaining={activationsRemaining}
      />
    ))
    .getOrElse(() => (
      <OverAllocated
        newLicenseAllocations={newLicenseAllocations}
        productLicensePublicName={publicName}
        activationsRemaining={activationsRemaining}
      />
    ));
}

export default observer(ActivationsRemaining);
